import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useAlert } from "hooks/useAlert";
import { RevivnApiForm } from "components/Form/RevivnApiForm";
import { Field } from "formik";

interface PriceComparisonFormValues {
  model: string;
  testData: "mac" | "pc";
}

const PriceComparisonPage: React.FC = () => {
  const { alertSuccess, alertError } = useAlert();
  const [error, setError] = useState<string | null>(null);
  const formId = "price-comparison-form";

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Price Comparison
        </Typography>

        <RevivnApiForm<PriceComparisonFormValues, any>
          FormProps={{ id: formId }}
          initialValues={{ model: "linear-price-model", testData: "mac" }}
          action="inventories/compare_prices"
          method="POST"
          onSubmit={() => {
            setError(null);
          }}
          onSuccess={() => {
            alertSuccess("Price comparison job has been queued. You will receive an email with the results.");
          }}
          onError={(err) => {
            const message = err.response?.data?.error?.message || "An error occurred";
            setError(message);
            alertError(`Failed to trigger price comparison: ${message}`);
          }}
        >
          <Stack spacing={3}>
            <FormControl fullWidth error={!!error}>
              <Field
                name="model"
                as={TextField}
                label="Price Model"
                required
                placeholder="Enter price model name"
                error={!!error}
                helperText={error}
              />
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="test-data-label">Test Data Type</InputLabel>
              <Field name="testData" as={Select} labelId="test-data-label" label="Test Data Type" required>
                <MenuItem value="mac">Mac</MenuItem>
                <MenuItem value="pc">PC</MenuItem>
              </Field>
              <FormHelperText>Select the type of test data to use for comparison</FormHelperText>
            </FormControl>

            <Box>
              <Button variant="contained" color="primary" type="submit" form={formId}>
                Generate Price Comparison
              </Button>
            </Box>

            <Typography variant="body2" color="text.secondary">
              This will generate a CSV comparing inventory prices from the selected model with the prices in our system.
              The report will be emailed to you when ready.
            </Typography>
          </Stack>
        </RevivnApiForm>
      </Paper>
    </Box>
  );
};

export default PriceComparisonPage;
